// extracted by mini-css-extract-plugin
export default {"accentGradient":"linear-gradient(62.22deg, #e4611e 17.77%, #ff792b 94.43%)"};